import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../mock";

export default function FAQ() {
  return (
    <section id="contact" className="bg-white">
      <div className="max-w-3xl mx-auto px-5 py-16">
        <h2 className="font-display text-3xl sm:text-4xl text-[#1f1a1b] text-center">Frequently Asked Questions</h2>
        <Accordion type="single" collapsible className="mt-10 w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/[0.08]">
              <AccordionTrigger className="text-left font-display text-lg text-[#1f1a1b] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#5a5254] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
